import Morpheus from "@tm/morpheus"
import { getBundleParams } from "@bundles/wheels/utils"

export function getShowIndustrialAvailability(stock?: number): boolean {
    const isWm = Morpheus.getParams("parts")?.templates?.articleItem?.bundle === "wm"

    if (isWm) {
        if (stock === -1) {
            return false
        }

        return !!getBundleParams().showIndustrialAvailability
    }

    return true
}
